import { defineStore } from "pinia";
import { ref } from "vue";
import Cache from "@/services/Cache";
import Emitter from "@/services/Emitter";
import Api from "@/services/Api";
import type { SessionModel } from "@/models/AccountModels";

interface AccountData {
    bearer: string | null;
    user: SessionModel | null;
}

export const useAppStore = defineStore("app", () => 
{
    const account = ref<AccountData>({
        bearer: null,
        user: null
    });
    const isInitialized = ref<boolean>(false);

    const init = (): void => {
        if (isInitialized.value) return;
        
        // Check cache for existing account data
        const tok: string | undefined = Cache.get("bearer");
        const usr: SessionModel | undefined = Cache.get("radar_user");

        if (tok && usr) {
            account.value.bearer = tok;
            account.value.user = usr;
        }
        
        isInitialized.value = true;
    };

    // Non Reactive Version 
    const getAccount = (): AccountData =>
    {
        init();
        
        return {
            bearer: account.value.bearer,
            user: account.value.user
        };
    };

    const setAccount = (rs: SessionModel | null): void =>
    {
        if (rs && rs.Token) 
        {
            account.value.bearer = rs.Token;
            account.value.user = rs;

            // set in the cache too ...
            Cache.set("bearer", account.value.bearer);
            Cache.set("radar_user", account.value.user);
        }

        else {

            account.value.bearer = "";
            account.value.user = null;

            Cache.set("bearer", account.value.bearer);
            Cache.set("radar_user", account.value.user);
        }
    };

    const refresh = (): void => {
        // Clear cached data and re-initialize
        Cache.unset("bearer");
        Cache.unset("radar_user");
        account.value.bearer = null;
        account.value.user = null;
        isInitialized.value = false;
    };

    // Register refresh event listener
    Emitter.on("refresh:appStore", () => {
        console.debug("refresh:appStore event received");
        refresh();
    });

    // Auto-initialize on store creation
    init();

    return { account, getAccount, setAccount, refresh }

});
